////////LIBRARY/////////
import React, { useEffect } from 'react'
import styled from 'styled-components'
///////COMPONENTS///////
import ModalPaper from './ModalPaper/ModalPaper'
import UseModalPosY from '../../hooks/UseModalPosY'

/////////STYLED/////////
const ModalsWrapper = styled.div`
	position: ${(props) => (props.insideModal ? 'absolute' : 'fixed')};
	top: ${(props) => (props.insideModal ? props.postop + 'px' : '0px')};
	left: 0;
	display: flex;
	justify-items: center;
	align-items: center;
	width: ${(props) => (props.insideModal ? '100%' : '100vw')};
	height: ${(props) => (props.insideModal ? '100%' : '100vh')};
	overflow: hidden;
	z-index: ${(props) => (props.insideModalResponse ? '60' : '52')};
`
const ModalBackground = styled.div`
	position: absolute;
	background-color: rgba(0, 0, 0, 0.75);
	opacity: 0.5;
	z-index: 40;
	width: 100vw;
	height: 100vh;
	top: 0px;
`
/////////STYLED/////////

/**
 *
 * @param showModal
 * @param closeModalHandler
 * @param children
 * @param title
 * @param level
 * @param name
 * @param insideModal
 * @param insideModalResponse
 * @param tabTitle
 * @param minWidth
 * @param maxWidth
 * @return {*}
 * @constructor
 */
const Modals = ({
	showModal,
	closeModalHandler,
	children,
	title,
	level,
	insideModal = false,
	insideModalResponse = false,
	tabTitle = false,
	minWidth,
	maxWidth,
	maxHeight,
	icon,
	width,
}) => {
	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (showModal) {
			document.body.style.overflow = 'hidden'
			document.body.style.paddingRight = '10px'
		}
		return () => {
			document.body.style.overflow = ''
			document.body.style.paddingRight = ''
		}
	}, [showModal])

	const [winPos] = UseModalPosY(showModal)

	let posTop = winPos.windowPageYOffset

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		showModal && (
			<ModalsWrapper postop={posTop} insideModal={insideModal} insideModalResponse={insideModalResponse}>
				<ModalPaper
					critical={1}
					headerTittle={title}
					closeModal={closeModalHandler}
					color={level}
					tabTitle={tabTitle}
					minWidth={minWidth}
					icon={icon}
					maxWidth={maxWidth}
					maxHeight={maxHeight}
					width={width}
				>
					{children}
				</ModalPaper>
				<ModalBackground postop={window.scrollY} onClick={closeModalHandler} />
			</ModalsWrapper>
		)
	)
}

Modals.propTypes = {}

Modals.defaultPropTypes = {}

export default Modals
